<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { AVAILABLE_EXTERNALS } from '$lib/constants';
  import { captureException } from '@sentry/sveltekit';

  import OAuthButton from '$components/OAuthButton.svelte';
  import Connection from './Connection.svelte';
  import Button from '$mds/Buttons/Button';
  import FontAwesomeIcon from '$components/FontAwesomeIcon.svelte';
  import { faCheck } from '@fortawesome/pro-solid-svg-icons';

  const dispatch = createEventDispatcher();

  export let customProviderText: string | null = null;
  export let connectText: string | null = null;
  export let connectMessage: string | null = null;
  export let removeText: string | null = null;
  export let type = 'connect';
  export let provider: keyof typeof AVAILABLE_EXTERNALS;
  export let providerParams = [];
  export let redirect: string | null = null;
  export let accountId: string | null = null;
  export let connected = false;
  export let account: string | null = null;
  export let canRemove = true;
  export let backgroundColor = 'bg-ondark-low';
  export let border = '';
  export let rounded = 'rounded-lg';

  let oauthButton;
  let loading = false;
  const display = AVAILABLE_EXTERNALS[provider];

  export async function onClick() {
    loading = true;
    try {
      await oauthButton.onClick();
      if (type === 'disconnect') {
        dispatch('remove');
      }
    } catch (error) {
      captureException(error);
    }
    loading = false;
  }
</script>

<Connection {backgroundColor} {border} {rounded}>
  <div slot="icon" class="flex shrink-0 rounded-lg">
    <OAuthButton
      bind:this={oauthButton}
      {provider}
      {providerParams}
      {redirect}
      {type}
      {accountId}
      disabled
      on:success={() => dispatch('connect')}
    />
  </div>

  <h2 slot="title" class="text-body-md text-ondark-primary mb-0.5">
    {customProviderText || display}
  </h2>
  <div slot="subtitle" class="flex items-center">
    {#if type === 'disconnect'}
      <div
        class="bg-positive-ondark-base text-onlight-secondary mr-2 flex h-3 w-3 items-center justify-center rounded-full md:h-4 md:w-4"
      >
        <FontAwesomeIcon icon={faCheck} class="h-2.5 w-2.5" />
      </div>
    {/if}
    <p class="tracking-0.01 text-ondark-secondary max-w-sm text-xs md:text-sm">
      {connectMessage ? connectMessage : account ? account : `Connect your ${display} account`}
    </p>
  </div>

  <div class="flex items-center space-x-4 md:ml-auto">
    <slot name="actions" />
    {#if connected}
      <Button variant="secondary" width="full" disabled={!canRemove} {loading} on:click={onClick}>
        {removeText ? removeText : 'Disconnect'}
      </Button>
    {:else}
      <Button variant="primary" width="full" on:click={onClick}>
        {connectText ? connectText : 'Connect'}
      </Button>
    {/if}
  </div>

  <div slot="footer">
    <slot />
  </div>
</Connection>
